module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("ACKNOWLEDGMENTS AND THANKS")])]), _vm._v(" "), _c('p', {
    staticClass: "s-txt"
  }, [_vm._v("First of all, we want to thank all of the talented sewists, designers, and bloggers who make up the amazing online sewing community. Without them, neither this book nor SewCanShe ("), _c('a', {
    attrs: {
      "href": "http://sewcanshe.com",
      "target": "_blank"
    }
  }, [_vm._v("sewcanshe.com")]), _vm._v(") would be possible.")]), _vm._v(" "), _c('p', {
    staticClass: "s-txt"
  }, [_vm._v("Second, we really must thank S. Truett Cathy, the founder of Chick-fil-A restaurants, for providing the perfect location for our weekly mommy-blogger business meetings. The ideas for this book first took shape while we sat in a Chick-fil-A booth drinking endless diet sodas as our preschoolers romped in the play area.")]), _vm._v(" "), _c('p', {
    staticClass: "s-txt"
  }, [_vm._v("Third, we owe a debt of gratitude to our agent, Linda; to the tireless editors at C&T for answering our many questions and guiding us through our first book-writing experience; and to the very generous shops and manufacturers that provided the fabric and supplies needed for the projects and photographs in the book (see "), _c('span', {
    attrs: {
      "href": "#/36_chapter30#link51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Where to Find It Online")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "s-txt"
  }, [_vm._v("Thank you all. We are honored to call you our friends!")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('b', [_vm._v("Caroline and Sarah")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0143ccd5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/05_acknowledgement.vue
// module id = 66
// module chunks = 0